import React from 'react';
import { inject, observer } from 'mobx-react';
import H5UserPostList from './h5';
import PCUserPostList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
interface UserMessageListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    currentPage?: number;
    pageSize?: number;
    thread?: ThreadAction
    data?: any
    type?: any   // 0是评论，1是@
    namespace?: string; // 允许外部指定 listStore 命名空间，默认 threadList
    listStore?: any; // 允许外部传入自定义 listStore（例如 topic.listStore）
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式

}
type UserMessageListAllProps = UserMessageListProps & RouteComponentProps;
interface UserMessageListState {
    recommendUserList: any
}
@inject('app', 'site', 'user', 'thread', 'topic')
@observer
class UserMessageList extends React.Component<UserMessageListAllProps, UserMessageListState> {
    constructor(props) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            recommendUserList: [],
        };
    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        

    }

    // 处理触底加载下一页
    handleLoadMore = () => {
    };


    // 去帖子详情页
    goDetails = (item, isPost) => {
        console.log(item, isPost, '跳转');
        
        const { thread, listStore, type } = this.props;
        const store = listStore || thread?.listStore;
        const post = item.data?.post;
        const threadData = item.data?.thread;
        
        // 1. 清理数据
        if (store?.setList) {
            store.setList({
                namespace: 'postList',
                data: { data: [] },
                page: 1,
                path: 'data',
                hasMore: true
            });
            store.setAttribute?.({
                namespace: 'postList',
                key: 'requestError',
                value: { isError: false, errorText: '' }
            });
        }
        
        if (thread && typeof thread.setThreadData === 'function') {
            thread.setThreadData(null);
        }
        
        // 2. 获取线程 ID
        let threadId;
        if (type === 1) {
            threadId = threadData?.id;
        } else if (type === 2) {
            threadId = post?.thread?.id || threadData?.id;
        } else {
            threadId = threadData?.id || post?.thread?.id;
        }
        
        if (!threadId) {
            console.error('无法获取 threadId');
            return;
        }
        
        // 3. 构建 URL 并跳转
        let url = `/threadDetail/${threadId}`;
        
        // 如果是点击评论（isPost=true）且是帖子类型（type=2），传递 postId
        if (isPost && post?.id) {
            url += `?postId=${post.id}`;
        }
        
        window.open(url);
    }


    // 去个人中心
    goUser = (user) => {
        console.log('跳转用户中心');
        if (this.props.history && user.code) {
            this.props.history.push(`/user/${user.code}`);
        }
    }

    // 点击评论按钮，打开评论弹框
    commentClick = (item) => {
        // 评论逻辑已在 h5/index.tsx 的 handleShowCommentInput 中处理
        // 这里保留作为父组件通知入口
    }

    // 更新 userNotificationsList 中嵌套 data.post / data.thread 的点赞状态
    updateNotificationLike = (id: any, isLiked: boolean, dataType: 'thread' | 'post') => {
        const { user } = this.props;
        const listData = user?.listStore?.lists?.['userNotificationsList']?.data;
        if (!listData) return;

        // type=0（评论）时 data 结构为 data.post，type=1（@帖）时为 data.thread
        const dataKey = dataType === 'thread' ? 'thread' : 'post';

        Object.keys(listData).forEach((page) => {
            listData[page].forEach((item: any, index: number) => {
                if (item.data?.[dataKey]?.id === id) {
                    listData[page][index] = {
                        ...item,
                        data: {
                            ...item.data,
                            [dataKey]: { ...item.data[dataKey], isLiked },
                        },
                    };
                }
            });
        });
    };

    //点赞帖子/评论（不刷新详情，直接更新 MobX）
    likeClick = async (data: any, type: 'thread' | 'post') => {
        const { user, thread } = this.props;
        const id = data?.id;
        if (!user || !id || !data) return;

        // 乐观更新：立即切换 isLiked 状态以获得更好的用户体验
        const isLiked = !data.isLiked;

        // 更新当前消息列表（userNotificationsList 在 user.listStore 中）
        this.updateNotificationLike(id, isLiked, type);

        const params = {
            id,
            type,
            isLiked,
            likeCount: data.likeCount,
        };

        try {
            // 调用 API 同步点赞状态
            await thread.createUserslikes(params);
        } catch (error) {
            // 请求失败，回滚点赞状态
            console.error('点赞操作失败', error);
            this.updateNotificationLike(id, data.isLiked, type);
            Toast.info('操作失败，请稍后重试');
        }
    }

    render() {
        const { site, app, data, type, thread, onLoadMore, loading: propsLoading, hasMore: propsHasMore, namespace = 'usersPostsList', listStore, searchKeyword, emptyText,  emptyIcon, emptyBoxStyle, ...props } = this.props;
        const platform = app?.platform || 'h5';
        let { recommendUserList } = this.state;
        // 确保传递 data 属性，即使为空数组
        const listData = data || [];

        // 优先使用父组件传递的 loading 和 hasMore，如果没有则从 thread store 获取
        const store = listStore || thread?.listStore;
        const loading = propsLoading !== undefined ? propsLoading : (store?.lists[namespace]?.loading || false);
        const hasMore = propsHasMore !== undefined ? propsHasMore : (store?.lists[namespace]?.hasMore ?? true);

        // 优先使用父组件传递的 onLoadMore，如果没有则使用默认的 handleLoadMore
        const loadMoreHandler = onLoadMore || this.handleLoadMore;

        if (platform === 'pc') {
            return <PCUserPostList
                goDetails={this.goDetails}
                goUser={this.goUser} {...props}
                data={listData}
                type={type}
                loading={loading}
                hasMore={hasMore}
                searchKeyword={searchKeyword}
                onLoadMore={loadMoreHandler}
                emptyText={emptyText}
                emptyIcon={emptyIcon}
                emptyBoxStyle={emptyBoxStyle}
                
            />;
        } else {
            return <H5UserPostList
            goDetails={this.goDetails}
            {...props} goUser={this.goUser}
            data={listData}
            type={type}
            loading={loading}
            hasMore={hasMore}
            searchKeyword={searchKeyword}
            onLoadMore={loadMoreHandler}
            emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
            commentClick={this.commentClick}
            likeClick={this.likeClick}
        />;
        }
    }
}

export default withRouter(UserMessageList);